
<script>
import http from '@/service/http'
import { mapState, mapGetters } from 'vuex'
import { ListSelect } from 'vue-search-select'
export default {
  name: 'Form',
  components: {
    ListSelect
  },
  data () {
    return {
      fornecedores: [],
      status: [],
      pagamentos: [],
      produtos: [],
      itemProduto: {
        id: '',
        produto: '',
        valor: '',
        qtd: ''
      },
      itemFornecedor: {
        id: '',
        fornecedor: ''
      },
      compra: {
        id: '',
        fornecedor_id: '',
        valor_frete: '',
        pagamento_id: '',
        prazo_entrega: '',
        obs: '',
        norma: '',
        status_id: 1,
        produtos: [],
        anexos: []
      },
      progress3: 0,
      errorFile3: false,
      options3: {
        url: `${process.env.API_URL}/upload-file`,
        uploadMultiple: false,
        acceptedFiles: '',
        headers: {
          path: 'compras',
          accept: 'all'
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    }
  },
  methods: {
    async fecth () {
      this.clear()
      const { id } = this.$route.params
      if (id !== undefined) {
        const { data } = await http.get(`/compras/${id}/edit`)
        this.compra = data.compra
        this.status = data.status
        this.pagamentos = data.pagamentos
        this.produtos = data.produtos
        this.fornecedores = data.fornecedores
      } else {
        const { data } = await http.get(`/compras/create`)
        this.status = data.status
        this.pagamentos = data.pagamentos
        this.produtos = data.produtos
        this.fornecedores = data.fornecedores
      }
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        }
        this.submit()
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/compras' : `/compras/${this.compra.id}`
      const { data } = await http[verb](url, this.compra)
      if (data != null) {
        if (this.gerar_os === true && this.compra.status_id === 5) {
          this.$router.push({ name: 'os.compra', params: { id: data.compra.id } })
        } else {
          this.$emit('update-compras-list', { compra: data.compra })
          this.$router.push({ name: 'compras.index' })
        }
      }
    },
    clear () {
      this.compra = {
        id: '',
        fornecedor_id: '',
        valor_frete: '',
        pagamento_id: '',
        prazo_entrega: '',
        obs: '',
        norma: '',
        status_id: 1,
        produtos: [],
        anexos: []
      }
    },
    totalProgress3 (progress, totalBytes, bytesSent) {
      this.progress3 = progress
    },
    complete3 (files, status, xhr) {
      if (files.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        this.compra.anexos.push({anexo: xhr.response, legenda: files.name})
        this.$nextTick(() => {
          window.Materialize.updateTextFields()
        })
        this.progress = 0
      }
    },
    destroyAnexo (indexAnexo) {
      this.$swal({
        title: 'Atenção',
        text: `excluir uma anexo é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        if (!this.compra.anexos[indexAnexo].id) {
          this.compra.anexos.splice(indexAnexo, 1)
          window.Materialize.toast('Anexo excluído!', 4000)
        } else {
          http.delete(`compras/anexo/${this.compra.anexos[indexAnexo].id}`)
            .then(response => response.data)
            .then(data => {
              window.Materialize.toast('Anexo excluído!', 4000)
              this.compra.anexos.splice(indexAnexo, 1)
            })
        }
      })
    },
    onSelectProduto (item) {
      if (item) {
        const produto = {
          produto_id: item.id,
          produto: item,
          valor: item.valor_compra,
          qtd: 1
        }
        this.addProduto(produto)
      }
    },
    async addProduto (produto) {
      await this.compra.produtos.push(produto)
      setTimeout(function () {
        window.Materialize.updateTextFields()
      }, 0)
    },
    destroyProduto (indexProduto) {
      this.$swal({
        title: 'Atenção',
        text: `excluir um Produto é uma operação irreversível`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        if (!this.compra.produtos[indexProduto].id) {
          this.compra.produtos.splice(indexProduto, 1)
          window.Materialize.toast('Produto excluído!', 4000)
        } else {
          http.delete(`compras/produto/${this.compra.produtos[indexProduto].id}`)
          .then(response => response.data)
          .then(data => {
            window.Materialize.toast('Produto excluído!', 4000)
            this.compra.produtos.splice(indexProduto, 1)
          })
        }
      })
    },
    valor_total () {
      let valor = 0
      let frete = this.compra.valor_frete ? this.compra.valor_frete : 0
      if (typeof this.compra.produtos !== 'undefined') {
        this.compra.produtos.forEach(function (produto) {
          valor += parseFloat(produto.valor) * parseInt(produto.qtd)
        })
      }
      return parseFloat(parseFloat(valor) + parseFloat(frete)).toFixed(2)
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['permissoes']),
    isNew () {
      return this.compra.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    },
    url_app () {
      return process.env.API_URL
    }
  }
}
</script>

<template>
  <div>

    <form>

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">

            <div class="col s12 m3">
              <label :for="`pagamento_id`">Fornecedor</label>
              <select :name="`fornecedor`" :id="`fornecedor`" v-model="compra.fornecedor_id">
                <option v-for="fornecedor in fornecedores" :value="fornecedor.id">{{ fornecedor.fornecedor }}</option>
              </select>
              <small class="red-text">{{ errors.first('pagamento_id') }}</small>
            </div>

            <div class="col s12 m3">
              <label :for="`pagamento_id`">Condição de Pagamento</label>
              <select :name="`pagamento_id`" :id="`pagamento_id`" v-model="compra.pagamento_id">
                <option v-for="pagamento in pagamentos" :value="pagamento.id">{{ pagamento.pagamento }}</option>
              </select>
              <small class="red-text">{{ errors.first('pagamento_id') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <input :name="`prazo_entrega`" :id="`prazo_entrega`" type="text" v-model="compra.prazo_entrega">
              <label :for="`prazo_entrega`">Prazo de Entrega</label>
              <small class="red-text">{{ errors.first('prazo_entrega') }}</small>
            </div>

            <div class="input-field col s12 m3">
              <input :name="`valor_frete`" :id="`valor_frete`" type="number" step="any" v-model="compra.valor_frete">
              <label :for="`valor_frete`">R$ Frete</label>
              <small class="red-text">{{ errors.first('valor_frete') }}</small>
            </div>

          </div>

          <div class="row">
            <div class="input-field col s12" @click="setPropostaIndex(indexProposta)">
              <list-select :list="produtos"
                           option-value="id"
                           option-text="produto"
                           :selected-item="itemProduto"
                           placeholder="Adicionar Produto"
                           @select="onSelectProduto">
              </list-select>
            </div>
          </div>

          <div class="row" v-show="compra.produtos && compra.produtos.length > 0">
            <div class="col s12">
              <table class="responsive-table bordered highlight">
                <tr>
                  <th>Produtos da Compra</th>
                  <th>% IPI</th>
                  <th>Qtd</th>
                  <th>Valor</th>
                  <th>Valor Total</th>
                  <th class="right-align">Excluir</th>
                </tr>
                <tr v-for="(produto, indexProduto) in compra.produtos">
                  <td>
                    <p>{{ (produto.produto) ? produto.produto.produto : '-' }}</p>
                  </td>
                  <td>
                    <input type="number" step="any" :id="`ipi${indexProduto}`" v-model="produto.ipi" min="1" style="margin-bottom: 0">
                  </td>
                  <td>
                    <input type="number" :id="`qtdProduto${indexProduto}`" v-model="produto.qtd" min="1" style="margin-bottom: 0">
                  </td>
                  <td>
                    <input type="number" step="any" :id="`valorProduto${indexProduto}`" v-model="produto.valor" min="1" style="margin-bottom: 0">
                  </td>
                  <td>
                    <input type="number" step="any" :id="`valorTotalProduto${indexProduto}`" :value="parseFloat(produto.valor * produto.qtd).toFixed(2)" style="margin-bottom: 0" readonly>
                  </td>
                  <td>
                    <div class="right-align">
                      <a href="#" @click.prevent="destroyProduto(indexProduto)">
                        <i class="material-icons red-text">delete_forever</i>
                      </a>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="row">

            <div class="input-field col s12 m3 offset-m9">
              <input :name="`valor_total`" :id="`valor_total`" type="number" step="any" min="0" :value="valor_total()" readonly>
              <label :for="`valor_total`">Valor Total</label>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <textarea :name="`obs`" :id="`obs`" class="materialize-textarea" v-model="compra.obs"></textarea>
              <label :for="`valor_total`">Obs</label>
              <small class="red-text">{{ errors.first('obs') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <textarea :name="`norma`" :id="`norma`" class="materialize-textarea" v-model="compra.norma"></textarea>
              <label :for="`valor_total`">Conforme Norma</label>
              <small class="red-text">{{ errors.first('norma') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options3" :on-complete="complete3" :on-total-progress="totalProgress3">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card center">
                          <span class="card-title">Anexos</span>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress3}%`"></div>
                      </div>
                      <div v-if="errorFile3" class="center-align">Tipo de arquivo inválido</div>
                      <div v-if="compra.anexo" class="center-align">
                        <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i>
                        <a :href="`${api_url}/compras/${compra.anexo}`" target="_blank"><i
                          class="material-icons pointer">search</i></a>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

          </div>

          <div class="row">
            <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in compra.anexos">
              <div class="row">
                <div class="col s12 m2">
                  <br>
                  <a :href="`${api_url}/compras/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
                </div>
                <div class="input-field col s12 m7">
                  <input name="legenda" :id="`legenda-${indexAnexo}`" type="text"
                         v-model="anexo.legenda"/>
                  <label :for="`legenda-${indexAnexo}`">Legenda</label>
                </div>
                <div class="col s12 m2">
                  <br>
                  <a href="#" @click.prevent="destroyAnexo(indexAnexo)">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </div>
              </div>
              <br clear="all"/>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m4">
              <label for="status_id">*Status</label>
              <select name="status_id" id="status_id" v-validate data-vv-rules="required" v-model="compra.status_id">
                <option v-for="status in status" :value="status.id">{{ status.status }}</option>
              </select>
              <small class="red-text">{{ errors.first('status_id') }}</small>
            </div>

          </div>

          <div class="row">

            <div class="col s12">
              <button type="button" @click.prevent="validate" class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/compras/compras/form.vue